// Meta sidebar — audit timestamps + matched rule (drives checklist NA flags).
// Composes EntityAuditMeta for the audit-driven created/updated trail and
// passes the rule row as `extraRows`. logistics_employee_id is owned by
// TransactionTransport now — keep it out of here to avoid duplication.

import React from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import type { Transaction } from "@shared/types/transaction";
import { EntityAuditMeta } from "@ds/connected/EntityAuditMeta";
import { EmptyValue } from "@ds/display/EmptyValue";
import type { KVItem } from "@ds/layout/KVGrid";

interface TxWithRule extends Transaction {
  rule?: { id: number; name?: string | null } | null;
}

export interface TransactionMetaProps {
  transaction: Transaction;
}

export const TransactionMeta: React.FC<TransactionMetaProps> = ({ transaction }) => {
  const { t } = useTranslation();
  const tx = transaction as TxWithRule;

  const extraRows: KVItem[] = [
    {
      label: t("transactions.fields.rule", "Reguła"),
      value: tx.rule?.id
        ? <Link to={`/settings/rules/edit/${tx.rule.id}`}>{tx.rule.name ?? `#${tx.rule.id}`}</Link>
        : <EmptyValue />,
    },
  ];
  return (
    <EntityAuditMeta
      entityType="transaction"
      entityId={tx.id}
      createdAt={tx.created_at}
      updatedAt={tx.updated_at}
      extraRows={extraRows}
    />
  );
};
